// Çerez/analitik izni: CookieBanner ve CookieManager tercihleri buradan kaydeder.
// Kayıt sonrası Google Consent Mode güncellenir ve aynı sekmedeki dinleyicilere
// (sayfa takibi) olay yayınlanır; diğer sekmeler "storage" olayıyla haberdar olur.

export const COOKIE_PREFS_KEY = 'cookiePreferences';
export const CONSENT_EVENT = 'odazen:cookie-consent-changed';

export const readCookiePreferences = () => {
  try {
    const raw = localStorage.getItem(COOKIE_PREFS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const hasAnalyticsConsent = () => readCookiePreferences()?.analytics === true;

/** Google Consent Mode v2: kullanıcının seçimine göre izinleri günceller. */
export const applyGtagConsent = (prefs) => {
  try {
    if (typeof window.gtag !== 'function' || !prefs) return;
    const ads = prefs.advertising === true ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      analytics_storage: prefs.analytics === true ? 'granted' : 'denied',
      ad_storage: ads,
      ad_user_data: ads,
      ad_personalization: ads,
    });
  } catch {
    // gtag yüklenemediyse sessizce geç
  }
};

export const saveCookiePreferences = (prefs) => {
  const value = { ...prefs, essential: true, timestamp: new Date().toISOString() };
  try {
    localStorage.setItem(COOKIE_PREFS_KEY, JSON.stringify(value));
  } catch {
    // depolama kapalı olabilir
  }
  applyGtagConsent(value);
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  } catch {
    // eski tarayıcı
  }
  return value;
};
